import Cookies from 'js-cookie';

const supportedUTMParams = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content', 'utm_term'];
const allSupportedParams = [...supportedUTMParams];
const UTMsParamMapping = {
    utm_source: 'landr_utmSource',
    utm_campaign: 'landr_utmCampaign',
    utm_medium: 'landr_utmMedium',
    utm_content: 'landr_utmContent',
    utm_term: 'landr_utmTerm',
};
const saveUTMsToCookies = (UTMCookieSettings) => {
    const queryParams = new URLSearchParams(window.location.search);
    let isSupportedUTMParamsInURL = false;
    // Detect if any UTMs exist in the URL
    queryParams.forEach((value, param) => {
        if (supportedUTMParams.includes(param)) {
            isSupportedUTMParamsInURL = true;
        }
    });
    // Remove all UTM related Cookies if URL contains UTM params
    // BUT DO NOT remove partner params
    if (isSupportedUTMParamsInURL) {
        supportedUTMParams.forEach((param) => {
            Cookies.remove(param, UTMCookieSettings);
        });
    }
    // Set UTM params in cookies
    queryParams.forEach((value, param) => {
        if (allSupportedParams.includes(param)) {
            Cookies.set(param, value, UTMCookieSettings);
        }
    });
};
const getUTMsParams = (UTMCookieSettings) => {
    const UTMs = {};
    // First save UTMs to cookies, this will make sure we capture new UTMs from URL
    saveUTMsToCookies(UTMCookieSettings);
    // Then get them
    allSupportedParams.forEach((param) => {
        if (Cookies.get(param)) {
            UTMs[UTMsParamMapping[param]] = Cookies.get(param);
        }
    });
    // Add document referrer
    if (document.referrer) {
        UTMs.landr_utmDocumentReferrer = document.referrer;
    }
    return UTMs;
};

export { getUTMsParams, saveUTMsToCookies, supportedUTMParams };
